module.exports = __webpack_public_path__ + "static/img/top_ly.52f12d40.png";